import React, { memo, useMemo } from 'react';
import { createUseStyles, Text, Advice } from '@Sage/hoi-poi-ui';

import styles from './styles';
const useStyles = createUseStyles(styles, 'StepHeader');

const StepHeader = ({ title, subtitle, errors, children = null }) => {
    const classes = useStyles();
    const getErrors = useMemo(() => {
        if (!errors?.length) return null;
        return errors.map((error, index) => (
            <Advice key={index} className={classes.error} type="error">
                {error}
            </Advice>
        ));
    }, [classes.error, errors]);

    return (
        <div className={classes.stepHeader}>
            <div className={classes.stepHeaderContent}>
                <div className={classes.headerContent}>
                    <Text bold size="large">
                        {title}
                    </Text>
                    <Text className={classes.stepSubtitle}>{subtitle}</Text>
                </div>
                {children}
            </div>
            {getErrors}
        </div>
    );
};

StepHeader.propTypes = {};

export default memo(StepHeader);
